<template>
  <div
    class="autocomplete autocomplete--small"
    :class="{ 'autocomplete--has-value': hasValue }"
  >
    <v-autocomplete
      v-model="model"
      :placeholder="label"
      prepend-inner-icon="search"
      :search-input.sync="search"
      :items="list"
      :loading="isLoading"
      color="accent"
      item-text="name"
      item-value="id"
      noDataText=""
      return-object
      hide-no-data
      hide-selected
      hide-details
      clearable
      outline
      solo
      flat
      @input="updateInput"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isObject, isArray } from 'utils/functions'
import debounce from 'lodash.debounce'

export default {
  name: 'AutoCompleteAsync',
  props: {
    input: {
      type: Object,
      defaut: null
    },
    service: String,
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    clear: Boolean
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    hasValue () {
      return this.isValidArray(this.model) || this.isValidArray(this.model)
    }
  },
  data () {
    return {
      namespace: 'Components.AutoCompleteAsync',
      model: null,
      search: null,
      isLoading: false,
      list: []
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    isValidArray (val) {
      return isArray(val)
    },

    resetFields () {
      this.model = null
      this.model = null
      this.search = null
      this.isLoading = false
      this.list = []
    },

    async searchAPI (val) {
      this.isLoading = true

      try {
        const company = this.selectedCompany ? this.selectedCompany.id : null
        const { data: res } = await this.$apiService.genericGet(
          this.service,
          { search: val },
          { company },
          { limit: 25 },
          { page: 1 }
        )

        this.list = res.data
      } catch (err) {
        console.log('Error', err)
        this.showAlert({ type: 'error', message: this.$t('Messages.genericError') })
      }

      this.isLoading = false
    },

    updateInput (input) {
      if (!input) this.list = []
      this.$emit('change', input)
    },

    searchInput: debounce(function () {
      this.isLoading = false
      this.searchAPI(this.search)
    }, 1000)
  },

  watch: {
    selectedCompany (val) {
      this.model = null
    },

    input (val) {
      this.model = val
    },

    search (val) {
      if (this.model && val === this.model.name) return
      val && this.searchInput(val)
    },

    clear (val) {
      this.resetFields()
    }
  }
}
</script>
